<template>
  <div class="commodity-sale-detail" data-test="commodity-sale-detail">
    <div class="wrapper" v-if="renderObj.id">
      <div class="top-bg">
        <van-icon class="l" 
          :name="(renderObj.status==1&&renderObj.isRefund==0) ? 'underway' : 
            (renderObj.status==2&&renderObj.isRefund==0) ? 'checked' : 
            (renderObj.isRefund==1) ? 'clear' : ''" 
          size="calc(var(--w) * 24)" />
        <div class="r">
          <div class="r1">{{statusObj[renderObj.status]}}
            <template v-if="renderObj.isRefund==1">{{renderObj.transderStatus==1?'（已结转）':'（已退费）'}}</template>
          </div>
          <div class="r2" v-if="renderObj.status == 2">
            <template>发货时间：{{renderObj.writeOffTime | formatDatetime('yyyy-MM-dd')}}</template>
          </div>
        </div>
      </div>
      <div class="b1">
        <div class="l1">{{ renderObj.studentName }}</div>
        <div class="l2 van-hairline--bottom">{{ renderObj.goodsName  }}
          <template v-if="renderObj.commodityPriceType==2"> · {{renderObj.priceItemNames}}</template>
        </div>
        <van-cell
          title="校区"
          :value="renderObj.campusName"
          :border="false"
          title-class="tc"
          value-class="vc"
        />
        <van-cell
          title="购买数量"
          :value="`${renderObj.quantity}${renderObj.unitName}`"
          :border="false"
          title-class="tc"
          value-class="vc"
        />
      </div>
      <template v-if="renderObj.isRefund == 1">
        <!-- 结转 -->
          <template v-if="renderObj.transderStatus == 1">
            <div class="card-wrapper" v-for="(itm,idx) in renderObj.transderList" :key="idx">
              <van-cell 
                title="查看关联结转订单"
                title-class="tctil" 
                is-link 
                :border="false"
                class="tctcell"
                @click="toOrderDetail">
              </van-cell>
              <div class="card-content">
                <van-cell
                  title="结转单号"
                  :value="itm.transderOrderNo"
                  :border="false"
                  title-class="tc"
                  value-class="vc"
                />
                <van-cell
                  title="学员"
                  :value="renderObj.studentName"
                  :border="false"
                  title-class="tc"
                  value-class="vc"
                />
                <van-cell
                  title="经办人"
                  :value="itm.transderName"
                  :border="false"
                  title-class="tc"
                  value-class="vc"
                />
                <van-cell
                  title="结转时间"
                  :value="app.tool.date.formatDatetime(itm.transderTime, 'yyyy-MM-dd hh:mm')"
                  :border="false"
                  title-class="tc"
                  value-class="vc"
                />
                <van-cell
                  title="退回库存"
                  :value="itm.isRefundSk == 1 ? '是' : '否'"
                  :border="false"
                  title-class="tc"
                  value-class="vc"
                />
              </div>
            </div>
          </template>
        <!-- 退费 -->
        <template v-else>
          <div class="card-wrapper" v-for="(itm,idx) in renderObj.refundList" :key="idx">
            <van-cell 
              title="查看关联退费订单"
              title-class="tctil" 
              is-link 
              :border="false"
              class="tctcell"
              @click="toOrderDetail">
            </van-cell>
            <div class="card-content">
              <van-cell
                title="退费单号"
                :value="itm.refundOrderNo"
                :border="false"
                title-class="tc"
                value-class="vc"
              />
              <van-cell
                title="学员"
                :value="renderObj.studentName"
                :border="false"
                title-class="tc"
                value-class="vc"
              />
              <van-cell
                title="经办人"
                :value="itm.refunderName"
                :border="false"
                title-class="tc"
                value-class="vc"
              />
              <van-cell
                title="退费时间"
                :value="app.tool.date.formatDatetime(itm.refundTime, 'yyyy-MM-dd hh:mm')"
                :border="false"
                title-class="tc"
                value-class="vc"
              />
              <van-cell
                title="退回库存"
                :value="itm.isRefundSk == 1 ? '是' : '否'"
                :border="false"
                title-class="tc"
                value-class="vc"
              />
            </div>
          </div>
        </template>
      </template>
      <div class="card-wrapper" v-else>
        <van-cell 
          title="查看关联订单"
          title-class="tctil" 
          is-link 
          :border="false"
          class="tctcell"
          @click="toOrderDetail">
        </van-cell>
        <div class="card-content">
          <van-cell
            title="订单号"
            :value="renderObj.orderNo"
            :border="false"
            title-class="tc"
            value-class="vc"
          />
          <van-cell
            title="学员"
            :value="renderObj.studentName"
            :border="false"
            title-class="tc"
            value-class="vc"
          />
          <van-cell
            title="创建人"
            :value="renderObj.orderCreateName"
            :border="false"
            title-class="tc"
            value-class="vc"
          />
          <van-cell
            title="下单时间"
            :value="renderObj.orderCreateTime | formatDatetime('yyyy-MM-dd hh:mm:ss')"
            :border="false"
            title-class="tc"
            value-class="vc"
          />
          <van-cell
            title="支付时间"
            :value="renderObj.orderPayTime | formatDatetime(renderObj.payType==2?'yyyy-MM-dd':'yyyy-MM-dd hh:mm:ss')"
            :border="false"
            title-class="tc"
            value-class="vc"
          />
        </div>
      </div>
    </div>
    <pageFooterBtn multipleBtns 
      v-if="((renderObj.isRefund==0&&renderObj.status==1) || renderObj.status==2) && app.permission.op('commodityWriteOff')">
      <van-button
        type="primary"
        square round
        block
        @click.stop="changeFilledStatus"
        v-if="renderObj.isRefund==0&&renderObj.status==1"
      >发货</van-button>
      <van-button
        type="default"
        square round
        block
        @click.stop="changeFilledStatus"
        v-if="renderObj.status==2"
      >修改为未发货</van-button>
    </pageFooterBtn>
  </div>
</template>

<script>
import pageFooterBtn from '@x3/vue/comp/page-footer-btn.vue';

export default {
  name: 'commodity-sale-detail',
  data() {
    return {
      pageTitle: '销售记录详情',
      id: '',
      renderObj: {},
      statusObj: {
        1: '未发货',
        2: '已发货',
      }
    }
  },
  methods: {
    loadDetail() {
      this.showLoading();
      this.$api.getGoodsWriteOff({
        id: this.id
      }).then(res=> {
        this.$toast.clear();
        if (res.code == 200) {
          this.renderObj = res.data;
        } else {
          this.$toast.fail(res.msg);
        }
      })
    },
    toOrderDetail() {
      this.$router.push(`/orderDetail/${this.renderObj.orderId}/${this.renderObj.orderType}/${this.renderObj.orderSourceType}`);
    },
    changeFilledStatus() {
      this.$dialog.confirm({
        title: "提示",
        message: `${this.renderObj.status==1?'是否将销售记录标记为已发货？': '修改后记录将标记为未发货，原有发货时间将清空，是否确认修改？'}`,
        confirmButtonText: `${this.renderObj.status==1?'确定':'修改'}`,
        cancelButtonText: '取消',
      }).then(res => {
        this.showLoading();
        this.$api.writeOffSingle({
          id: this.renderObj.id,
          status: this.renderObj.status==1?2:1
        }).then(res=> {
          this.$toast.clear();
          if (res.code===200) {
            this.$toast.success(`${this.renderObj.status==1?'已标记发货':'已修改为未发货'}`);
            setTimeout(()=>{
              this.loadDetail();
                app.vue.$emit("refresh-commodity-sale-list");
            }, 300);
          } else{
            this.$toast.fail(res.msg);
          }
        });
      });
    },
  },
  created() {
    this.id = this.$route.params.id;
    this.loadDetail();
  },
  components: {
    pageFooterBtn
  }
}
</script>

<style lang="scss" scoped>
.commodity-sale-detail {
  display: flex;
  flex-direction: column;
  .wrapper {
    flex: 1;
    overflow: auto;
    .top-bg {
      padding: calc(var(--gap) * 18) calc(var(--gap) * 16) 0;
      height: calc(var(--w) * 100);
      color: var(--white);
      background: var(--c1);
      display: flex;
      &.gray {
        background: var(--g5);
      }
      .l {
        margin-right: calc(var(--gap) * 8);
      }
      .r {
        .r1 {
          font-size: var(--fs-ex1);
          line-height: var(--lh-ex1);
        }
        .r2 {
          padding-top: calc(var(--gap) * 2);
          font-size: var(--fs-sm);
          line-height: var(--lh-sm);
          opacity: 0.8;
        }
      }
    }
    .b1 {
      margin-top: -18px;
      margin-left: calc(var(--gap) * 16);
      margin-right: calc(var(--gap) * 16);
      padding: calc(var(--gap) * 16);
      border-radius: 8px;
      background: var(--white);
      overflow: hidden;
      .l1 {
        color: var(--g8);
        font-size: var(--fs-lg);
        line-height: var(--lh-lg);
        font-weight: 600;
      }
      .l2 {
        padding: calc(var(--gap) * 4) 0 calc(var(--gap) * 12) 0;
        color: var(--g7);
        font-size: var(--fs-md);
        line-height: var(--lh-md);
      }
      .van-cell {
        padding: calc(var(--gap) * 12) 0 0 0;
      }
    }
    .card-wrapper {
      margin: calc(var(--gap) * 12) calc(var(--gap) * 16);
      padding-bottom: calc(var(--gap) * 16);
      background-color: var(--white);
      border-radius: var(--radius-sm);
      overflow: hidden;
      .tctcell {
        padding: calc(var(--gap) * 16) calc(var(--gap) * 16) 0 calc(var(--gap) * 16);
        .tctil {
          font-size:var(--fs-lg);
          line-height:var(--lh-lg);
          color: var(--g8);
        }
      }
      .card-content {
        .van-cell {
          padding: calc(var(--gap) * 12) calc(var(--gap) * 16) 0 calc(var(--gap) * 16);
        }
      }
    }
    .van-cell {
      font-size:var(--fs-md);
      line-height:var(--lh-md);
      .tc {
        color: var(--g6);
      }
      .vc {
        color: var(--g7);
      }
    }
  }
}
</style>